<template>
    <div class="detail-header">
        <div class="title">
          {{ $t('COMMON_UPLOAD') }}
        </div>
        <div class="guide-tip">
            <svg-icon icon-name="icon-guidance" :size="20" icon-color="#00b8f5"></svg-icon>
        </div>
        <div v-html="$t('split_file_tip')" class="guide-content-container"> 
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/svgIcon/index'
  export default {
    name: 'UploadTitleTips',
    components:{SvgIcon},
    props: {
      title: {
        type: String,
        default: () => {
          return ''
        }
      },
      tips: {
        type: String,
        default: () => {
          return ''
        }
      },
    },
    data() {
      return {
        
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
.detail-header {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.title {
    margin-right: 10px;
}
.guide-tip{
    background: #00b8f5;
    border-radius: 5px;
    width: 24px;
    height: 24px;
    text-align: center;
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.guide-content-container{
    font-size: 12PX;
    margin-right: 30px;
}
</style>